import { IconButton } from "@mui/material";
import { colors } from "../../theme/muiColors";
import { cloneElement } from "react";

export const IconButtonComponent = ({ onClick, children, sx, sxIcon, theme = "grey", disabled = false }) => {
  return (
    <IconButton
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      sx={{
        bgcolor: disabled
          ? colors.grey[300]
          : theme === "grey"
          ? colors.grey[300]
          : theme === "orange"
          ? colors.orange[100]
          : theme === "colorized"
          ? colors.blue[100]
          : colors.blue[100],
        right: 0,
        top: 0,
        ...sx,
        "&:hover": {
          bgcolor: disabled
            ? colors.grey[300]
            : theme === "grey"
            ? colors.blue[100]
            : theme === "orange"
            ? colors.orange[200]
            : theme === "colorized"
            ? colors.blue[300]
            : colors.blue[300],
        },
      }}
    >
      {cloneElement(children, sxIcon)}
    </IconButton>
  );
};
